import {post, get} from "./request";
const businessURL = '/api'

//获取数据源配置列表
const apiCustomformDatasourceConfigList = (params) => {
    return post(`/customform/datasourceconfig/list`, params)
}

//删除数据源配置数据
const apiCustomformDatasourceConfigDelete = (params) => {
    return post(`/customform/datasourceconfig/delete`, params)
}

//获取详情数据
const apiCustomformDatasourceConfigGet = (id) => {
    return get(`/customform/datasourceconfig/get?id=${id}`, {})
}

//测试连接
const apiCustomformDatasourceConfigCheckConnectStatus = (url, username, password) => {
    return get(`/customform/datasourceconfig/checkConnectStatus?url=${url}&username=${username}&password=${password}`, {})
}

//保存数据源配置数据
const apiCustomformDatasourceConfigSave = (params) => {
    return post(`/customform/datasourceconfig/save`, params)
}

export {
    apiCustomformDatasourceConfigSave,
    apiCustomformDatasourceConfigCheckConnectStatus,
    apiCustomformDatasourceConfigList,
    apiCustomformDatasourceConfigDelete,
    apiCustomformDatasourceConfigGet,
}